class InvalidStatusCode extends Error {
    constructor(status) {
        super(`HTTP status code '${status}' is not a valid status code`);
    }
}
export default InvalidStatusCode;
